<template>
    <div class="profile__table__box table-responsive">
        <table
            id="vehicles__table"
            class="profile__table table"
            cellpadding="0"
            cellmargin="0"
            width="100%"
        >
            <thead>
                <tr>
                    <th>Nº Orden</th>
                    <th>Placa</th>
                    <th>Taller</th>
                    <th>Estado</th>
                    <th>Total</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="element in list" :key="element.id">
                    <td class="text-center">{{ element.order_number }}</td>
                    <td class="text-center">{{ element.vehicle.plate }}</td>
                    <td class="text-center">{{ element.garage_name }}</td>
                    <td class="text-center">{{ element.order_status_name }}</td>
                    <td class="text-right">
                        {{ element.total ? 'S/ ' + element.total : '' }}
                    </td>
                    <td class="text-right">
                        <a
                            href="#"
                            class="confirm_services"
                            @click.prevent="openModal(element.id)"
                            data-tooltip="tooltip"
                            data-bs-placement="top"
                            title="Revisar trabajos"
                            v-if="element.code == '031'"
                        >
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="427.69px"
                                height="427.83px"
                                viewBox="0 0 427.69 427.83"
                                style="enable-background: new 0 0 427.69 427.83"
                                xml:space="preserve"
                            >
                                <g id="layer1_1_" transform="translate(0 -290.65)">
                                    <path
                                        id="circle2017_1_"
                                        vector-effect="none"
                                        d="M191.96,290.65C86.17,290.65,0,376.82,0,482.61 c0,105.78,86.17,192.13,191.96,192.13c45.18,0,86.74-15.83,119.58-42.13l79.96,79.92c8.52,8.18,22.05,7.9,30.23-0.61 c7.94-8.27,7.95-21.32,0.02-29.6l-79.96-79.96c26.31-32.89,42.17-74.51,42.17-119.75C383.96,376.82,297.74,290.65,191.96,290.65 L191.96,290.65z M191.96,333.32c82.73,0,149.29,66.56,149.29,149.29s-66.56,149.46-149.29,149.46S42.67,565.34,42.67,482.61 S109.23,333.32,191.96,333.32L191.96,333.32z"
                                    />
                                </g>
                            </svg>
                        </a>
                        <a
                            href="#"
                            class="paid_services"
                            @click.prevent="getPreference(element.id, element.garage_id)"
                            data-tooltip="tooltip"
                            data-bs-placement="top"
                            title="Realizar pago"
                            v-if="element.code == '051'"
                        >
                            <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="512px"
                                height="352px"
                                viewBox="0 0 512 352"
                                style="enable-background: new 0 0 512 352"
                                xml:space="preserve"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M512,83V56c0-30.93-25.07-56-56-56H56C25.07,0,0,25.07,0,56v27c0,2.76,2.24,5,5,5h502C509.76,88,512,85.76,512,83z"
                                        />
                                        <path
                                            d="M0,125v171c0,30.93,25.07,56,56,56h400c30.93,0,56-25.07,56-56V125c0-2.76-2.24-5-5-5H5C2.24,120,0,122.24,0,125z M128,256c0,8.84-7.16,16-16,16H96c-8.84,0-16-7.16-16-16v-16c0-8.84,7.16-16,16-16h16c8.84,0,16,7.16,16,16V256z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <profile-order-modal
        :url_store="url_store"
        @refresh-table="getList()"
        @close-modal="closeModal()"
    ></profile-order-modal>
</template>

<script>
import axios from 'axios'
import { inject, provide, ref } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
    props: {
        public_key: {
            type: String,
            default: '',
        },
        url_list: {
            type: String,
            default: '',
        },
        url_detail: {
            type: String,
            default: '',
        },
        url_store: {
            type: String,
            default: '',
        },
        url_preference: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const loading = inject('loading')

        const list = ref([])
        const order = ref({})

        provide('order', order)

        const getList = async () => {
            try {
                const { data } = await axios.request({
                    url: props.url_list,
                    method: 'POST',
                })

                list.value = data
            } catch (error) {
                console.error(error)
            }
        }
        getList()

        const getDetail = async (id) => {
            try {
                const { data } = await axios.request({
                    url: props.url_detail,
                    method: 'POST',
                    data: {
                        id: id,
                    },
                })

                order.value = data
            } catch (error) {
                console.error(error)
            }
        }

        const getPreference = async (id, garage_id) => {
            try {
                const { data } = await axios.request({
                    url: props.url_preference,
                    method: 'POST',
                    data: {
                        id: id,
                        garage_id: garage_id,
                    },
                })

                // console.log(data);
                window.location.href = data
            } catch (error) {
                console.error(error)
            }
        }

        const openModal = async (id) => {
            // loading.value = true;

            await getDetail(id)

            loading.value = false

            $('#confirmServicesModal').modal('show')
        }

        const closeModal = async () => {
            order.value = {}

            $('#confirmServicesModal').modal('hide')
        }

        return {
            list,
            getList,
            getPreference,
            openModal,
            closeModal,
        }
    },
}
</script>
